import { User } from 'services/api/definitions/account.definitions';

export const getFriendNames = (friends: User[]) => {
  if (friends.length === 1) {
    return {
      id: `game.details.friends_playing.one`,
      values: { name1: friends[0].username },
    };
  }

  if (friends.length === 2) {
    return {
      id: `game.details.friends_playing.two`,
      values: { name1: friends[0].username, name2: friends[1].username },
    };
  }

  if (friends.length === 3) {
    return {
      id: `game.details.friends_playing.three`,
      values: {
        name1: friends[0].username,
        name2: friends[1].username,
        name3: friends[2].username,
      },
    };
  }

  if (friends.length === 4) {
    return {
      id: `game.details.friends_playing.four`,
      values: {
        name1: friends[0].username,
        name2: friends[1].username,
        name3: friends[2].username,
        name4: friends[3].username,
      },
    };
  }

  return {
    id: `game.details.friends_playing.many`,
    values: {
      name1: friends[0].username,
      name2: friends[1].username,
      name3: friends[2].username,
      count: friends.length - 3,
    },
  };
};
